import { Component, EventEmitter, Input, Inject, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';


@Component({
  selector: 'app-telemedicine-modal',
  templateUrl: './telemedicine-modal.component.html',
  styleUrls: ['./telemedicine-modal.component.css']
})
export class TelemedicineModalComponent implements OnInit{
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
  public dialog: MatDialog, 
  public matDialogRef: MatDialogRef<TelemedicineModalComponent>,
  private alertService: AlertService,) { }

  public isLoading: boolean = false;
  public colorCode: string = '#99C8D6';
  public goTelemedicine: boolean;
  public buttonName: string;
  public buttonDescription: string;

  ngOnInit(): void {
    this.goTelemedicine = false;
    this.buttonName = this.data.buttonName;
    this.buttonDescription = this.data.buttonDescription;
  }

  advance() {
    this.goTelemedicine = true;
    this.matDialogRef.close({isAdvanced: this.goTelemedicine}); 
  }

  close() {
    this.goTelemedicine = false;
    this.matDialogRef.close();
  }
}
